import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../../config/config';
import { Creators } from './actions';
// import { createActions } from 'reduxsauce';

// *************************** Fetch Single Review Saga ***************************
export function* fetchSingleReviewSaga(action) {
  try {
    yield put(Creators.fetchSingleReviewStart());
    let url, res;
    let singleReview = [];
    if (action.postSlug !== null) {
      url = yield `${apiEndpoints.singleReview}/${action.postSlug}`;
      res = yield axios.get(url);
    } else {
      // Return so that Review is not infinite.
      return;
      // eslint-disable-next-line
      // url = yield `${apiEndpoints.getMorePosts}/${action.timeStamp}`;
      // res = yield axios.get(url);
    }
    // console.log('res: ', res);
    // if (res.data.success === 1) {
    if (res.status === 200) {
      for (let key in res.data.post) {
        singleReview.push({
          id: key,
          ...res.data.post[key]
        });
      }
    }
    let payload = {
      postSlug: action.postSlug,
      singleReview: singleReview
    };
    // console.log('singleReview: ', singleReview);
    yield put(Creators.fetchSingleReviewSuccess(payload));
    let tagId, postId;
    if (res.data.post[0].tags && res.data.post[0].tags[0]) {
      tagId = res.data.post[0].tags[0];
    } else {
      tagId = null;
    }
    // console.log('res.data: ', res.data);
    postId = res.data.post[0].id;
    // console.log('tagId: ', tagId);
    // console.log('postId: ', postId);
    yield put(Creators.fetchRelatedArticlesForSingleReview(tagId, postId));
  } catch (err) {
    yield put(Creators.fetchSingleReviewFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Related Articles Saga ***************************
export function* fetchRelatedArticlesForSingleReviewSaga(action) {
  // console.log('action: ', action);
  try {
    yield put(Creators.fetchRelatedArticlesForSingleReviewStart());
    // console.log('action: ', action);
    let urlForRelatedArticle, urlForFetchingTags;
    let relatedArticles = [],
      tagsList = [];
    if (action.tagId === null) {
      relatedArticles = [];
      tagsList = [];
    } else {
      urlForRelatedArticle = yield `${apiEndpoints.relatedArticles}/${
        action.tagId
      }/${action.postId}`;
      urlForFetchingTags = yield `${apiEndpoints.fetchTagsList}/${
        action.postId
      }`;
      const res = yield axios.get(urlForRelatedArticle);
      const resForTags = yield axios.get(urlForFetchingTags);
      // console.log('action: ', action);
      // console.log('urlForFetchingTags: ', urlForFetchingTags);
      // console.log('resForTags: ', resForTags);

      if (res.data.success === 1) {
        for (let key in res.data.related) {
          relatedArticles.push({
            id: key,
            ...res.data.related[key]
          });
        }
      }

      // console.log('resForTags.data.success: ', resForTags.data.success);
      if (resForTags.data.success === 1) {
        for (let key in resForTags.data.tags) {
          tagsList.push({
            id: key,
            ...resForTags.data.tags[key]
          });
        }
      }
      // console.log('tagsList: ', tagsList);
    }
    // console.log('relatedArticles: ', relatedArticles);

    yield put(
      Creators.fetchRelatedArticlesForSingleReviewSuccess({
        relatedArticles,
        tagsList
      })
    );
  } catch (err) {
    console.log('err: ', err);
    yield put(Creators.fetchRelatedArticlesForSingleReviewFailure(err));
  }
}
// ______________________________________________________________________________
